export default "__VITE_ASSET__BqWKjdeX__"